import type { TreeNodeData } from '../../types'

export const traverseTree = (
  treeData: TreeNodeData[],
  callback: CallableFunction,
  pnode?: TreeNodeData,
  pnodes?: TreeNodeData[]
) => {
  treeData.every((node, index) => {
    let result

    if (callback) {
      result = callback(
        node,
        pnode,
        pnodes?.length ? pnodes : [pnode].filter((item) => !!item),
        index
      )
    }

    // 回调函数返回false则终止遍历
    if (result !== false) {
      traverseTree(node.children || [], callback, node, [
        node,
        ...(pnodes || []),
      ])
    }

    return result !== false
  })

  return treeData
}
